<template>
  <div class="sidebar">
    <!-- <div class="nav-header" style="background:#333">
            <div style="padding:20px 0;text-align: center;">
                <img src="../../assets/qxlogo02.png" alt="" style="width:120px;height:90px;background:#fff;display:inline-block">
            </div> -->
    <!-- <div style="font-size:18px;text-align: center;padding-bottom:30px;color:#fff">
                <p style="margin:10px">齐心总部</p>
                <p>操作员:{{name}}</p>
            </div> -->
    <!-- </div> -->
    <!-- <div class="nav" v-if="false">
            <div class="navName" v-for="(item,index) in menuList" :key="index" :class="{active:curNav==index}" @click="navClick(item,index)">
                <router-link :to="item.path">
                    <img :src="item.icon" :alt="item.title">
                    <span>{{item.title}}</span>
                </router-link>
            </div>
        </div> -->
	<div class="nav-header">
		<span class="large-text">齐心BMS业务管理平台</span>
		<span class="mini-text">BMS</span>
	</div>
    <div class="navChild">
        <!-- 首页 -->
        <div class="navChildName" :class="{active:onRoutes==homeMenu.path}">
            <router-link class="navLink" :to="homeMenu.path">
              <i class="menu-icon" :class="homeMenu.menuIcon"></i>
              <span>{{homeMenu.name}}</span>
            </router-link>
        </div>
        <!-- 首页 end -->
		<div class="navChildName" v-for="(item,num) in childMenuList" :key="num">
			<a class="navLink" @click="operate(num)">
				<i class="menu-icon" :class="item.menuIcon"></i>
				<span>{{item.title}}</span>
				<span class="el-icon-arrow-right menu-arrow" :class="{rotate:item.rotate}"></span>
			</a>
			<div class="navChildName"
				v-for="(childItem,index) in item.children"
				:key="index"
				:class="{active:onRoutes==childItem.path,off:item.requireAuth,on:!item.requireAuth}"
				@click="navChildClick(childItem,index)"
				style="transition:all .6s;">
				<router-link :to="childItem.path">
					<i v-if="childItem.menuIcon" :class="childItem.menuIcon" class="cp-sidebar-child-icon"></i>
					<span>{{childItem.title}}</span>
				</router-link>
			</div>
		</div>
      <!-- <div class="navChildName" v-for="(childItem,index) in childMenuList" :key="index" :class="{active:onRoutes==childItem.path}" @click="navChildClick(childItem,index)">
                <router-link :to="childItem.path">
                    <i :class="'menu-icon '+childItem.menuIcon"></i>
                    <span>{{childItem.title}}</span>
                </router-link>
            </div> -->
    </div>
    <div class="navbar-btn"
         @click="navbarToggle"><i class="el-icon-arrow-left"></i><i class="el-icon-arrow-right"></i></div>
  </div>
</template>
<script>
import menuList from '@/common/menuList.js'
export default {
  name: "sidebar",
  data () {
    return {
      childMenuList: [],
      curNav: 0,
      curChildNav: 0,
      menu: JSON.parse(sessionStorage.getItem("MENULIST")),
      menuIndexArr: []
    }
  },
  created () {
    // this.childMenuList = menuList
    const topMenuPathSet = new Set();
    this.menu.forEach((item, index) => {
        if(menuList[item.imgPath]){
            let arr = [];
            const childPathSet = new Set();
            item.children.forEach((item1, index1) => {
                if(menuList[item.imgPath].children[item1.imgPath]){
                    const childCfg = menuList[item.imgPath].children[item1.imgPath];
                    // 调用子菜单去重逻辑：同一一级菜单内按 path 去重，避免重复“集采订单”。
                    if (!childPathSet.has(childCfg.path)) {
                        childPathSet.add(childCfg.path);
                        arr.push(childCfg);
                    }
                };
            });
            const topCfg = menuList[item.imgPath];
            // 调用一级菜单去重逻辑：按 path 去重，避免重复“集采结算管理”。
            if (topMenuPathSet.has(topCfg.path)) {
                return;
            }
            topMenuPathSet.add(topCfg.path);
            this.childMenuList.push({
                path: topCfg.path,
                title: topCfg.title,
                resoureUrl: topCfg.resoureUrl,
                menuIcon: topCfg.menuIcon,
                requireAuth: topCfg.requireAuth,
                rotate: topCfg.rotate,
                children: arr
            });
        };
    });
    // 与其它菜单保持一致：仅按后端 MENULIST + menuList 映射构建，不做静态二次追加。
    // this.childMenuList[0].requireAuth = false;
    // this.childMenuList[0].rotate = true;
  },
  computed: {
    onRoutes () {
		return this.$route.path;
      // if (this.$route.path.replace('/', '') == 'registerReceipt') {
      //   return 'registerReceipt'
      // } else {
      //   return this.$route.path.replace('/', '');
      // }
    },
    homeMenu(){
        return this.$router.options.routes[0].children[0];
    },
  },
  methods: {
    operate (index) {
      this.childMenuList[index].requireAuth = !this.childMenuList[index].requireAuth;
      this.childMenuList[index].rotate = !this.childMenuList[index].rotate;
    },
    navClick (item, index) {
      this.childMenuList = item.children
      this.curNav = index
      // this.$store.dispatch('setBreadcrumb',[
      //     {
      //         path:item.path,
      //         name:item.title,
      //     },
      //     {
      //         path:item.path,
      //         name:this.childMenuList[0].title,
      //     },
      // ])
    },
    navChildClick (item, index) {
      this.curChildNav = index
      // this.$store.dispatch('setBreadcrumb',[
      //     this.$store.state.breadcrumbArr[0],
      //     {
      //         path:item.path,
      //         name:item.menuName,
      //     },
      // ])
    },
    navbarToggle () {
      let obj = document.getElementsByClassName("wrapper")[0];
      if (obj.classList.contains('mini-navbar') == true) {
        obj.classList.remove("mini-navbar");
        obj.classList.add("nav-child-hide", "mini-navbar-animate");
        setTimeout(function () { obj.classList.remove("nav-child-hide") }, 200);
        setTimeout(function () { obj.classList.remove("mini-navbar-animate") }, 250);
      } else {
        obj.classList.add("mini-navbar");
      }
    }
  }
}
</script>
<style lang="less" scoped>
.sidebar {
  display: block;
  width: 190px;
  background-color: #304156;
  position: absolute;
  left: 0;
  top: 0px;
  bottom: 0;
  transition: width 0.3s ease-in-out;
  overflow: hidden;
}
.nav-header {
	height: 50px;
	line-height: 50px;
	text-align: center;
	font-weight: bold;
	font-size: 15px;
	color: #fff;
	overflow: hidden;
	.mini-text {
		display: none;
	}
}
.navChild {
  width: 190px;
  height: calc(100% - 50px);
  opacity: 1;
  overflow-y: auto;
  transition: opacity 0.2s ease-in-out;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
}
.navChild::-webkit-scrollbar {
  width: 0;
}
.navChildName a {
	display: block;
	min-height: 20px;
	line-height: 20px;
	text-align: left;
	font-size: 15px;
	font-weight: bold;
	color: #BFCBD9;
	padding: 10px 18px 10px 45px;
	position: relative;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	&:hover {
		background-color: #263445;
	}
}
.navChildName {
	background-color: #000;
	.navLink {
		cursor: pointer;
		background-color: #304156;
	}
}

.pf_icon1 {
  background: url(../../assets/pf_icon1.png) no-repeat;
  width: 20px;
  height: 21px;
  background-size: 100%;
  position: absolute;
  left: 13px;
}
.pf_icon2 {
  background: url(../../assets/pf_icon2.png) no-repeat;
  width: 20px;
  height: 21px;
  background-size: 100%;
  position: absolute;
  left: 13px;
}
.pf_icon3 {
  background: url(../../assets/pf_icon3.png) no-repeat;
  width: 20px;
  height: 21px;
  background-size: 100%;
  position: absolute;
  left: 13px;
}
.pf_icon4 {
  background: url(../../assets/pf_icon4.png) no-repeat;
  width: 20px;
  height: 21px;
  background-size: 100%;
  position: absolute;
  left: 13px;
}
.pf_icon5 {
  background: url(../../assets/pf_icon5.png) no-repeat;
  width: 20px;
  height: 21px;
  background-size: 100%;
  position: absolute;
  left: 13px;
}
.pf_icon6 {
  background: url(../../assets/pf_icon6.png) no-repeat;
  width: 20px;
  height: 21px;
  background-size: 100%;
  position: absolute;
  left: 13px;
}
.rp_icon1 {
  background: url(../../assets/rp_icon1.png) no-repeat;
  width: 20px;
  height: 21px;
  background-size: 100%;
  position: absolute;
  left: 13px;
}
.rp_icon2 {
  background: url(../../assets/rp_icon2.png) no-repeat;
  width: 20px;
  height: 21px;
  background-size: 100%;
  position: absolute;
  left: 13px;
}
.rp_icon3 {
  background: url(../../assets/rp_icon3.png) no-repeat;
  width: 20px;
  height: 21px;
  background-size: 100%;
  position: absolute;
  left: 13px;
}
.rp_icon4 {
  background: url(../../assets/rp_icon4.png) no-repeat;
  width: 20px;
  height: 21px;
  background-size: 100%;
  position: absolute;
  left: 13px;
}
.rp_icon5 {
  background: url(../../assets/rp_icon5.png) no-repeat;
  width: 20px;
  height: 21px;
  background-size: 100%;
  position: absolute;
  left: 13px;
}

.servicer_message {
  background: url(../../assets/servicer_message.png) no-repeat;
  width: 20px;
  height: 21px;
  background-size: 100%;
  position: absolute;
  left: 13px;
}
.platform_message {
  background: url(../../assets/platform_message.png) no-repeat;
  width: 20px;
  height: 21px;
  background-size: 100%;
  position: absolute;
  left: 13px;
}
.menu-icon {
  display: block;
  width: 18px;
  height: 100%;
  line-height: 40px;
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  font-size: 16px;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  position: absolute;
  left: 13px;
  top: 0;
}
.menu-icon1 {
	background-image: url(../../assets/menu1.png);
}
.menu-icon2 {
	background-image: url(../../assets/menu2.png);
}
.menu-icon3 {
	background-image: url(../../assets/menu3.png);
}
.menu-icon4 {
	background-image: url(../../assets/menu4.png);
}
.menu-icon5 {
	background-image: url(../../assets/menu5.png);
}
.menu-icon6 {
	background-image: url(../../assets/menu6.png);
}
.menu-icon7 {
	background-image: url(../../assets/menu7.png);
}
.menu-icon8 {
	background-image: url(../../assets/menu8.png);
}
.menu-icon9 {
	background-image: url(../../assets/menu9.png);
}
.menu-icon10 {
	background-image: url(../../assets/menu10.png);
}
.menu-arrow {
	transition:all .3s;
	float: right;
	margin-top: 3px;
}
.navChildName.active a {
	background-color: #1F2D3D;
	color: #409EFF;
}
.navChildName.active .menu-icon {
  left: 16px;
}
.navbar-btn {
  width: 14px;
  height: 100px;
  line-height: 100px;
  background-color: #888;
  border-radius: 10px 0 0 10px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -50px;
  cursor: pointer;
  overflow: hidden;
}
.navbar-btn .el-icon-arrow-right {
  display: none;
}
.mini-navbar .sidebar {
  width: 66px;
  .large-text {
	display: none;
  }
  .mini-text {
	display: block;
  }
}
.mini-navbar .navChild {
  width: 100%;
}
.mini-navbar .navChildName a {
  padding-left: 0;
  border: none;
}
.mini-navbar .navChildName a span {
  display: none;
}
.mini-navbar .navChildName .menu-icon {
  left: 50%;
  margin-left: -10px;
}
.mini-navbar .navbar-btn .el-icon-arrow-left {
  display: none;
}
.mini-navbar .navbar-btn .el-icon-arrow-right {
  display: inline-block;
}
.mini-navbar-animate .navChild {
  opacity: 0;
}
.nav-child-hide .navChild {
  display: none;
}
.off {
  overflow: hidden;
  max-height: 0;
}
.on {
  max-height: 500px;
}
.rotate {
  transform: rotateZ(90deg);
}
.cp-sidebar-child-icon {
  margin-right: 6px;
  font-size: 14px;
  vertical-align: middle;
}
/*
    .sidebar-el-menu:not(.el-menu--collapse){
        width: 200px;
    }
    .nav{
        width: 80px;
        background: #333;
        height: 100%;
        float: left;
    }
    .navName a{
        display: block;
        padding: 10px 0;
        text-align: center;
        color: #EDF0F7;
    }
    .navName.active {
        background: #18508A;
    }
    .navName img {
        display: block;
        margin: 0 auto;
    }
 */
</style>